<template>
    <div
        class="video-container"
        :style="customStyle"
        v-if="videoId !== ''"
    >
        <vue-plyr
            ref="videoPlayer"
            v-if="showPlayer"
        >
            <iframe
                :src="youtubeEmbedUrl"
                allowfullscreen allowtransparency allow="autoplay">
            </iframe>
        </vue-plyr>
    </div>
</template>

<script>
    import VuePlyr from 'vue-plyr';

    const getYouTubeId = (url) => {
        const arr = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        return undefined !== arr[2] ? arr[2].split(/[^\w-]/i)[0] : arr[0];
    }

    export default {
        components: {VuePlyr},
        props: ['videoId', 'showPlayer'],

        data() {
            return {
                width: '0',
                height: '0',
            }
        },
        watch: {
          showPlayer: function (){
            this.$forceUpdate();
          }
        },
        computed: {
            youtubeVideoId: function () {
                return getYouTubeId(this.videoId);
                // let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                // let match = this.videoId.match(regExp);
                // return (match && match[7].length === 11) ? match[7] : this.videoId;
            },
            youtubeEmbedUrl: function() {
                return 'https://www.youtube.com/embed/' + this.youtubeVideoId + '?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1'
            },
            customStyle: function () {
                return {
                    backgroundImage: "url('https://img.youtube.com/vi/" + this.youtubeVideoId + "/maxresdefault.jpg')",
                    width: this.width,
                    height: this.height
                }
            },
        },
        mounted: function () {
            let availableWidth = $('.main-container').innerWidth();
            let aspectRatio = (537 / 1362);

            this.height = aspectRatio * availableWidth + 'px';
            this.width = availableWidth + 'px';
        }
    }
</script>
